import {TraderDBAccount} from '@qep/types/src/index';

export async function getUserAccountsFromTraderDB(): Promise<TraderDBAccount[]> {
  return globalThis.QEP.apiServices.account.getUserAccountsFromTraderDB();
}
